export const blockIconsPhotoandimageLooksOneNew = (
	<span className='material-symbols-outlined'>looks_one</span>
);
